import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { formatNumbersToCurrencyString } from 'utils/utils';
import GlobalTooltip from 'components/GlobalTooltip';

const AvailableTrustFund = (props) => {
  const {
    selectedInvoice,
    trustBalance,
    trustAccountData,
    setTrustAccountData,
    formErrors,
    setFormErrors,
    accountList,
    totalAmount,
    depositInfo,
    setDepositInfo,
    setIsChanged,
  } = props || {};

  const [selectedDepositInto, setSelectedDepositInto] = useState();
  const [selectedDepositInfo, setSelectedDepositInfo] = useState();

  useEffect(() => {
    if (!selectedDepositInto || !selectedDepositInfo) {
      setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
      return;
    }

    if (selectedDepositInto.account_id === selectedDepositInfo.account_id) {
      setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
    } else {
      if (selectedDepositInto.account_type === selectedDepositInfo.account_type) {
        setFormErrors((prev) => ({
          ...prev,
          deposit_Info: 'Cannot select two different accounts of the same type',
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, deposit_Info: '' }));
      }
    }
  }, [selectedDepositInto, selectedDepositInfo]);

  return (
    <div>
      {/* TODO:doubt two tables are there */}
      {/* TODO:must fix direct state mutation */}
      {/* TODO:body and editor templates */}

      {!selectedInvoice && trustBalance?.trust_data?.length > 0 && trustAccountData && (
        <div className="mt-3">
          <div className="caption-bold mb-2">Trust Fund Allocation</div>
          <div className="col-12 shadow-small datatable-responsive">
            <DataTable value={[trustAccountData]} className="p-datatable-responsive">
              <Column
                header="Account"
                // body={(rowData, props) => {
                //   return (
                //     <>
                //       <span className="p-column-title text-break">Account</span>
                //       <span>
                //         <Dropdown
                //           options={trustBalance.trust_data}
                //           optionLabel="trust_account_name"
                //           value={{
                //             trust_account_id: rowData?.debit_account_id,
                //             trust_account_name: rowData?.debit_account_name,
                //             trust_balance: rowData?.amount_available,
                //           }}
                //           onChange={(e) => {
                //             trustAccountData.debit_account_id = e?.target?.value?.trust_account_id;
                //             trustAccountData.debit_account_name = e?.target?.value?.trust_account_name;
                //             trustAccountData.amount_available = e?.target?.value?.trust_balance;
                //             trustAccountData.amount_paid = 0;
                //             setTrustAccountData({ ...trustAccountData });
                //           }}
                //           className="input-shadow w-100"
                //           filter
                //         />
                //       </span>
                //     </>
                //   );
                // }}
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Account</span>
                      <span className="text-break">{rowData?.debit_account_name}</span>
                    </>
                  );
                }}
              />
              <Column
                header="Amount Available"
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Amount Available</span>
                      <span className="text-break">{formatNumbersToCurrencyString(rowData?.amount_available)}</span>
                    </>
                  );
                }}
              />
              <Column
                header="Amount To Apply"
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Amount to Apply From Trust</span>
                      <span className="text-break">{formatNumbersToCurrencyString(rowData?.amount_paid)}</span>
                    </>
                  );
                }}
                editor={(props) => {
                  return (
                    <div>
                      <InputText
                        className="input-shadow w-50"
                        placeholder="amount"
                        min={0}
                        max={props?.rowData?.trust_balance ? parseFloat(props?.rowData?.trust_balance) : 0}
                        type="number"
                        value={props?.rowData?.amount_paid}
                        onChange={(e) => {
                          let amount_paid = e.target.value;
                          amount_paid = parseFloat(amount_paid);
                          trustAccountData.amount_paid = amount_paid;
                          setTrustAccountData({ ...trustAccountData });
                          formErrors.amount_paid = '';
                          setFormErrors({ ...formErrors });
                        }}
                      />
                      {formErrors?.amount_paid && <span className="text-danger">{formErrors?.amount_paid}</span>}
                    </div>
                  );
                }}
              />
              <Column
                header="Balance in Trust After Allocation"
                body={(rowData) => {
                  let amount_paid = rowData?.amount_paid;
                  let amount_available = rowData?.amount_available;
                  if (amount_paid && amount_available) {
                    let d = parseFloat(amount_available) - parseFloat(amount_paid);
                    return (
                      <>
                        <span className="p-column-title text-break">Balance in Trust After Allocation</span>
                        <span className="text-break">{formatNumbersToCurrencyString(d)}</span>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <span className="p-column-title text-break">Balance in Trust After Allocation</span>
                        <span className="text-break">-</span>
                      </>
                    );
                  }
                }}
              />

              <Column
                header={<span>Deposit Into{Boolean(trustAccountData?.amount_paid) && <span className="text-danger">*</span>}</span>}
                body={(rowData) => {
                  return (
                    <>
                      <span className="p-column-title text-break">Deposit Into</span>
                      <span>
                        <Dropdown
                          className="input-shadow w-100"
                          // options={accountList}
                          options={accountList?.filter((account) => account?.account_id !== rowData?.debit_account_id)}
                          optionLabel="account_name"
                          optionValue={(v) => ({ account_name: v?.account_name, account_id: v?.account_id, account_type: v?.account_type })}
                          value={{
                            account_name: rowData?.credit_account_name,
                            account_id: rowData?.credit_account_id,
                            account_type: rowData?.account_type,
                          }}
                          onChange={(e) => {
                            let account_name = e?.target?.value?.account_name;
                            let account_id = e.target?.value?.account_id;
                            let account_type = e?.target?.value?.account_type;
                            setTrustAccountData({
                              ...trustAccountData,
                              credit_account_name: account_name,
                              credit_account_id: account_id,
                              account_type: account_type,
                            });
                            formErrors.credit_account_name = '';
                            setFormErrors({ ...formErrors });
                            setSelectedDepositInto(e?.value);
                          }}
                          filter
                        />
                        {formErrors?.credit_account_name && <span className="text-danger">{formErrors?.credit_account_name}</span>}
                      </span>
                    </>
                  );
                }}
              />
            </DataTable>
          </div>
        </div>
      )}
      <div className="card-bg p-3 align-self-start mt-2">
        <div className="d-flex flex-wrap gap-md-5 gap-2">
          <div className="d-flex align-items-center">
            <div className="p-medium me-1 t-bold">Remaining Amount Due:</div>
            <span className="t-bold">{formatNumbersToCurrencyString(totalAmount - (trustAccountData?.amount_paid || 0))}</span>
          </div>
          <div className="d-flex align-items-center">
            <div className="p-medium me-2 pt-2">
              Deposit Info
              {totalAmount - (trustAccountData?.amount_paid || 0) > 0 && <span className="text-danger">*</span>}
            </div>
            <div className="d-flex flex-column">
              <GlobalTooltip
                tooltip={
                  selectedInvoice?.invoice_status?.toLowerCase() === 'partial'
                    ? 'Partially paid invoices deposit info cannot be updated'
                    : ''
                }
                showDelay={500}
              >
                <Dropdown
                  options={accountList || []}
                  optionLabel="account_name"
                  optionValue="account_id"
                  className="input-shadow"
                  placeholder="Deposit Info"
                  disabled={selectedInvoice?.invoice_status?.toLowerCase() === 'partial'}
                  value={depositInfo}
                  onChange={(e) => {
                    setDepositInfo(e.value);
                    setIsChanged((preVal) => ({ ...preVal, invoice: true }));
                    setFormErrors((preval) => ({ ...preval, deposit_Info: '' }));
                    setSelectedDepositInfo(accountList?.find((account) => account?.account_id === e?.value));
                  }}
                />
              </GlobalTooltip>
              {formErrors?.deposit_Info && <span className="text-danger">{formErrors?.deposit_Info}</span>}
            </div>
          </div>
        </div>
      </div>

      {selectedInvoice && trustAccountData?.amount_paid && (
        <div className="d-flex py-2 flex-wrap time-entries mt-3">
          <div className="col-12 caption-bold mb-2">Available Trust Funds</div>
          <div className="col-12 shadow-small">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Amount Paid</th>
                  <th>Deposit Into</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{trustAccountData?.debit_account_name}</td>
                  <td>{trustAccountData?.amount_paid}</td>
                  <td>{trustAccountData?.credit_account_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvailableTrustFund;
